import type { ReactNode } from "react"
import { ArrowRight } from "lucide-react"
import { cn } from "@/lib/utils"
import { CodeViewer, type CodeViewerProps } from "../CodeViewer/CodeViewer"

export interface CodePanelProps extends CodeViewerProps {
  isEmpty?: boolean
  emptyLabel?: ReactNode
  footerSlot?: ReactNode
  className?: string
}

export function CodePanel({
  isEmpty = false,
  emptyLabel,
  footerSlot,
  className,
  ...viewerProps
}: CodePanelProps) {
  if (isEmpty) {
    return (
      <div
        className={cn(
          "h-full flex items-center justify-center px-6",
          className,
        )}
      >
        <p className="text-caption text-muted-foreground text-center leading-relaxed">
          {emptyLabel ?? (
            <>
              Your strategy code will populate here. Use AI to create a strategy now.
              <ArrowRight
                size={14}
                strokeWidth={1.5}
                className="hidden min-[1100px]:inline-block align-middle ml-1"
              />
            </>
          )}
        </p>
      </div>
    )
  }
  return (
    <div className={cn("h-full flex flex-col relative", className)}>
      <CodeViewer {...viewerProps} />
      {footerSlot}
    </div>
  )
}
